import ApiClient from "@common/api/ApiClient";

class AlertConfigurationClient extends ApiClient {
  constructor() {
    super("AlertConfiguration");
    this.setApiUrlKey("comp_api_url");
  }

  getMetaData = async () => await this.get("Update");
}

const client = new AlertConfigurationClient();

export default client;
